// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".main{width:calc(100% - 5.125rem);display:flex;margin-left:auto;padding:1.5rem;position:relative}.main .platform{position:fixed;right:1.5rem}@media(min-width:84em){.main{width:calc(100% - 15.25rem);padding:2rem}.main .platform{right:2rem}}@media(min-width:120em){.main{width:calc(100% - 21rem);padding:2.5rem 3rem}.main .platform{right:3rem}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
